import { render, staticRenderFns } from "./IfValue.vue?vue&type=template&id=5889a357&scoped=true"
import script from "./IfValue.vue?vue&type=script&lang=js"
export * from "./IfValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889a357",
  null
  
)

export default component.exports